import { useTranslation } from "react-i18next";

const DataAbout = () => {
    const { t } = useTranslation();

    return [
        {
            id: 1,
            title: t('SAFE & SECURE'),
            text: t('We ensure 100% secure transactions with no ban guarantees for all EA FC 26 Coins purchases.')
        },
        {
            id: 2,
            title: t('LARGE INVENTORY'),
            text: t('Access a vast collection of EA FC 26 Coins for PlayStation, Xbox, and PC at the best prices.')
        },
        {
            id: 3,
            title: t('TRUSTED SOURCE'),
            text: t('Our store is a trusted platform for EA FC 26 Coins with years of proven reliability.')
        },
        {
            id: 4,
            title: t('COMMUNITY SUPPORT'),
            text: t('Join a big community of happy customers enjoying fast delivery and excellent service.')
        },
    ];
};

export default DataAbout;
